class ProductDetailActions extends ProductDetailActionsBase {
    constructor(el) {
        super(el);

        //Přihlášení uživatelé nemají tento text dostupný
        this.betterPriceForLoggedUserText = this.$find('[data-better-price-for-logged-user-text]');
        if (this.betterPriceForLoggedUserText) {
            this.loadLoginOpennerAndSetListener();
        }

        this.minimumOrderableAmountText = this.$find('[data-minimum-orderable-amount-text]');
        this.amountInput = this.$find('[data-input-up-down-base]');
    }

    onVariantChange(variant) {
        super.onVariantChange(variant);

        if (this.betterPriceForLoggedUserText) {
            this.betterPriceForLoggedUserText.innerHTML = variant.betterPriceForLoggedUserText
            this.loadLoginOpennerAndSetListener();
        }

        this.updateMinimumOrderableAmount(variant);
    }

    updateMinimumOrderableAmount(variant) {
        const min = parseInt(variant.minimumOrderableAmount, 10) || 1;

        if (this.minimumOrderableAmountText) {
            this.minimumOrderableAmountText.innerHTML = variant.minimumOrderableAmountText || '';
            this.minimumOrderableAmountText.classList.toggle('u-hidden', min <= 1);
        }

        if (!this.amountInput) {
            return;
        }

        this.amountInput.setAttribute('min', min);
        if (parseInt(this.amountInput.value, 10) < min) {
            this.amountInput.value = min;
        }

        const wrapper = this.amountInput.closest('[data-amount-input]');
        if (!wrapper) {
            return;
        }

        wrapper.dataset.min = min;

        const inputComp = wrapper.__inputUpDownBase__;
        if (inputComp && typeof inputComp.setMin === 'function') {
            inputComp.setMin(min);
        }
    }

    loadLoginOpennerAndSetListener() {
        this.loginOpener = this.$find('[data-login-opener]');
        this.loginOpener && this.loginOpener.addEventListener('click', () => this.openLogin());
    }

    openLogin() {
        EventBus.getInstance().dispatchEvent('showBasePopup', 'login-popup');
    }
}
